import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { ReactComponent as Cancel } from '../assets/cancel.svg';
import { Editor } from './Editor';
// import '../styles/NotificationAll.scss';

export default function NotificationAll ({saveNotificationAll, hideNotificationAll, project}) {
    const { register, reset, setValue, handleSubmit, formState: { errors } } = useForm();
    const [message, changeMessage] = useState('');
    const [filterType, setFilterType] = useState('all');
    const [minPoints, setMinPoints] = useState(0);
    const [maxPoints, setMaxPoints] = useState(0);
    const [selectedActivity, setSelectedActivity] = useState('');

    const setMessage = (text) => {
        changeMessage(text)
        setTimeout(() => {
            changeMessage();
        }, 3000);
    };

    const save = async (data) => {
        data['filterType'] = filterType;
        data['minPoints'] = minPoints;
        data['maxPoints'] = maxPoints;
        data['selectedActivity'] = selectedActivity;

        console.log(data);

        saveNotificationAll(data);
        hideNotificationAll();
    }

    return (
        <div className="wrapper">
            <div className="modal notification-all-modal">
                <div className="header">
                    <h2>Send notification to users</h2>
                    <button className="close-button" onClick={hideNotificationAll}>
                        <Cancel/>
                        <span>Close</span>
                    </button>
                </div>

                <form onSubmit={handleSubmit(save)}>
                    <div className="form-group">
                        <label htmlFor="filterType">Filter Users</label>
                        <select 
                            id="filterType"
                            onChange={(e) => setFilterType(e.target.value)} 
                            value={filterType}
                        >
                            <option value="all">All Users</option>
                            <option value="minPoints">Minimum Points</option>
                            <option value="maxPoints">Maximum Points</option>
                            <option value="activity">Completed Activity</option>
                        </select>
                    </div>

                    {filterType === 'minPoints' && (
                        <div className="form-group">
                            <label htmlFor="minPoints">Minimum Points</label>
                            <input 
                                id="minPoints"
                                type="number" 
                                value={minPoints} 
                                onChange={(e) => setMinPoints(e.target.value)}
                            />
                        </div>
                    )}

                    {filterType === 'maxPoints' && (
                        <div className="form-group">
                            <label htmlFor="maxPoints">Maximum Points</label>
                            <input 
                                id="maxPoints"
                                type="number" 
                                value={maxPoints} 
                                onChange={(e) => setMaxPoints(e.target.value)}
                            />
                        </div>
                    )}

                    {filterType === 'activity' && (
                        <div className="form-group">
                            <label htmlFor="selectedActivity">Select Activity</label>
                            <select 
                                id="selectedActivity"
                                onChange={(e) => setSelectedActivity(e.target.value)} 
                                value={selectedActivity}
                            >
                                <option value="">Select an activity</option>
                                {project.PACKETS.flatMap((packet, packetIndex) =>
                                    packet.activities.map((activity, activityIndex) => 
                                        activity && (
                                            <option key={`${packetIndex}-${activityIndex}`} value={`${packetIndex}-${activityIndex}`}>
                                                {packet.name} - {activity.name || `Activity ${activityIndex + 1}`}
                                            </option>
                                        )
                                    )
                                )}
                            </select>
                        </div>
                    )}

                    <div className="form-group">
                        <h3>SMS</h3>
                        <input type="text" {...register("sms")} />
                        <div className="error">{errors["sms"] ? errors["sms"].message : '' }</div>
                    </div>

                    <div className="form-group">
                        <h3>Email</h3>
                        <label className="label">Subject</label>
                        <input type="text" {...register("email[subject]")} />

                        <label className="label">Body</label>
                        <Editor
                            type=""
                            value=""
                            templates={[]}
                            register={register}
                            registerName={"email[html]"}
                            setValue={setValue}
                        />
                    </div>

                    <div className="button-group">
                        <button type="submit" className="button primary-button">Send notification</button>
                        <button type="button" className="button secondary-button" onClick={hideNotificationAll}>Cancel</button>
                    </div>

                    {message && <div className="error-message">{message}</div>}
                </form>
            </div>
        </div>
    )
}

